import propTypes from 'prop-types';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Moment from 'react-moment';
import { connect } from 'react-redux';

const ConferenceItem = ({
    auth,
    conference: { _id, rent, name, date, description },
}) => {

return (
    <Col>
        <Card border='warning'>
            <Card.Header>
                Conference Name : {name}
            </Card.Header>
            <Card.Body>
                <table className='room-card-table'>
                    <tbody>
                        <tr>
                            <td>
                                <tr><td>Date</td><td>{<Moment format='YYYY/MM/DD'>{date}</Moment>}</td></tr>
                                <tr><td>Rent</td><td>{rent}</td></tr>
                                <tr><td>Description</td><td>{description}</td></tr>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    </Col>
)};

ConferenceItem.propTypes = {
    conference: propTypes.object.isRequired,
    auth: propTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { })(
    ConferenceItem
);